/**
 * Update meta tags with new tag
 *
 * @param   {object}  newMeta
 * @return  {array}
 */
export const updateMetaTags = (newMeta) => {
    // Capture existing meta tags
    const currentMetaTags = document.querySelectorAll('meta[name], meta[property]');
    const previousMetaTags = Array.from(currentMetaTags).map(tag => ({
        name: tag.getAttribute('name'),
        property: tag.getAttribute('property'),
        content: tag.getAttribute('content'),
    }));

    // Remove current meta tags
    currentMetaTags.forEach(tag => tag.remove());

    // Add the new meta tag
    const metaTag = document.createElement('meta');
    metaTag.setAttribute('name', newMeta.name);
    metaTag.setAttribute('content', newMeta.content);
    document.head.appendChild(metaTag);

    // Return previous meta tags for potential restoration
    return previousMetaTags;
};

/**
 * Restore original meta tags
 *
 * @param   {array}  previousMetaTags
 */
export const restoreMetaTags = (previousMetaTags) => {
    // Restore previous meta tags
    previousMetaTags.forEach(tag => {
        const metaTag = document.createElement('meta');
        if (tag.name) metaTag.setAttribute('name', tag.name);
        if (tag.property) metaTag.setAttribute('property', tag.property);
        metaTag.setAttribute('content', tag.content);
        document.head.appendChild(metaTag);
    });
}